import wrapApp from './react/wrapApp'

const initClient = hooks => {
	hooks.render.wrapApp.tap('templates', wrapApp)
}

export default initClient
